<template>
  <div class="custom-cards-resultado-individual">
    <div class="custom-header">
      <p class="dark-0 p-16-custom">
        {{ this.$props.title }}
      </p>
      <div class="span-card mt-2"></div>
    </div>
    <div class="custom-body">
      <div v-for="(item, index) in items" :key="index">
        <p class="desc-custom custom-item">
          <img v-if="item.check" class="custom-img-icons"
            src='../../../assets/images/icon-check.svg'
          />
          <img
            v-if="!item.check"
            class="custom-img-icons"
            src='../../../assets/images/icon-error.svg'
          />
          {{ item.description }}
        </p>
      </div>
    </div>
    <div class="custom-footer">
      <div class="custom-align-footer">
        <p
          class="p2 primary custom-pointer"
          @click="onActioHandler(typeActionHandler, titleHandler)"
        >
          <img
            class="img-learn-more mr-2"
            src="../../../assets/images/MDI-information-new.svg"
          />
            Entenda este indicador
        </p>
      </div>      
      <div class="custom-align-footer">
        <p
          class="text-right p-16-custom color-green-2 w-100"
        >{{ this.onGetAdicional() }}</p>
      </div>      
    </div>
  </div>
</template>

<script>
import { isMobile } from '../../../utils/mobile/mobile';

export default {
  props: [
    "title",
    "porcentage",
    "onAction",
    "typeAction",
    "items",
  ],
  setup(props) {
    const onActioHandler = function(type, title) {
      props.onAction(type, title);
    };

    return { onActioHandler };
  },
  data() {
    return {
      typeActionHandler: "",
      titleHandler: "",
    }
  },
  components: {},
  mounted() {
    this.typeActionHandler = this.$props.typeAction ? this.$props.typeAction : "";
    this.titleHandler = this.$props.title ? this.$props.title : "";
  },
  methods: {
    isMobile: isMobile,
    onGetAdicional() {
      return "Ganho adicional " + this.$props.porcentage;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-align {
  text-align: right;
}
.custom-cards-resultado-individual {
  border-radius: 10px;
  background-color: #ffffff;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;

  width: 100%;
  height: 21.6rem;
}
.dark-0 {
  color: var(--dark-0);
}
.custom-header {
  height: 15%;
}
.custom-body {
  height: 60%;
  padding-top: 1.5rem;
}
.custom-footer {
  height: 25%;
  width: 100%;
  padding-bottom: 1.4rem !important;
  display: grid;
  grid-template-columns: auto 115px;
}
@media (max-width: 991px) {
  .custom-body {
    height: 63%;
  }
  .custom-footer {
    height: 22%;
  }
}
@media (max-width: 768px) {
  .custom-cards-resultado-individual {
    height: 23.6rem;
  }
  .custom-footer {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
}
@media (max-width: 698px) { 
  .custom-cards-resultado-individual {
    height: 21.6rem;
  }
  .custom-footer {
    display: grid;
    grid-template-columns: auto 115px;
    flex-direction: unset;
    justify-content: unset;
  }
  .custom-body {
    height: 60%;
  }
  .custom-footer {
    height: 25%;
  }
}
@media (max-width: 362px) {
  .custom-footer {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
}
.custom-align-footer {
  display: flex;
  justify-content: left;
  align-items: flex-end;
  align-content: flex-end;
}
.custom-align-footer p {
  display: flex;
}

.p-16-custom {
  font-size: multiplier-default-font-size(3); // 16
}
.span-card {
  width: 100%;
  height: 0.05rem;
  border-radius: 20%;
  background-color: var(--grey-3);
}
.custom-img-icons {
  height: 2rem;
  width: 2rem;
  margin-right: 0.8rem;
}
.custom-pointer {
  cursor: pointer;
}
.desc-custom {
  padding-bottom: 0.5rem;
}
.custom-item {
  font-size: multiplier-default-font-size(1); 
  color: var(--grey-1);
}
@media (max-width: 992px) {
  .p-16-custom {
    font-size: multiplier-default-font-size(2); // 14
  }
}
.primary {
  color: var(--primary);
}
.img-learn-more {
  height: 2rem;
  width: 2rem;
}
</style>
